import React, {useEffect, useState} from 'react';
import {
    GuaranteeCard, RentForm,
    PriceCard,
    ProductDescription,
    ProductDetailHeader,
    ProductImage,
    ProductTitle, SpecificationsCard, StorageAndDeliveryConditionsCard
} from "../../components";
import {Alert, Button, Divider, Flex, Modal, Skeleton} from "antd";
import RentFormPopUp from "../../components/ProductDetailContent/rentFormPopUp/RentFormPopUp";
import {connect} from "react-redux";
import {getProductThumbnail} from "../../../../shared";
import {withRouter} from "../../../../utils/services/with-router";
import {deleteProduct, getProductDetail} from "../../actions/Product.action";
import {MyProductDetailProps, ProductDetailProps} from "../../models";
import {useNavigate, useParams} from "react-router-dom";

const MyProductDetail = ({getProductDetail,deleteProduct} : MyProductDetailProps) => {
    const { id } = useParams();
    const [product, setProduct] =
        useState<any>();
    const [loading, setLoading] =
        useState<boolean>(false);
    const [deleteBtnLoading, setDeleteBtnLoading] =
        useState<boolean>(false);
    const navigate = useNavigate();
    const onCansel = () => {
        setOpen(false);
    }
    const [open, setOpen] = useState<boolean>(false);

    const _deleteProduct = () => {
        setDeleteBtnLoading(true);
        deleteProduct(id)
            .then((data: any) => {
                setDeleteBtnLoading(false);
                if (data.payload != undefined) {
                    navigate("/user-products")
                }
            })
            .catch((e: any) => {
            });
    };

    const _getProductThumbnail = () => {
        setLoading(true);
        getProductDetail(id)
            .then((data: any) => {
                setLoading(false);
                if (data.payload != undefined) {

                    setProduct(data.payload.data);

                }
            })
            .catch((e: any) => {
            });
    };
    useEffect(() => {
        _getProductThumbnail();
    }, []);
    return (


                 <Flex vertical justify={"center"} gap={"small"}>
                <ProductDetailHeader bookmarked={product?.isBookmarked}/>
               <Flex vertical justify={"center"} gap={"small"} style={{marginTop: "60px"}}>
                   <ProductImage product={product}/>


                   {loading ? <Flex vertical gap={"large"}>
                           <Skeleton active/>
                           <Skeleton.Input active={true} size={"small"} block />
                           <Skeleton.Input active={true} size={"small"} block />
                           <Skeleton.Input active={true} size={"small"} block />
                           <Skeleton.Input active={true} size={"small"} block />

                       </Flex> :
                       <Flex vertical justify={"center"} gap={"small"} >
                           <ProductTitle product={product}/>
                           <ProductDescription product={product}/>
                           <PriceCard product={product?.productPricings}/>
                           <GuaranteeCard product={product}/>
                           <SpecificationsCard product={product}/>
                           <StorageAndDeliveryConditionsCard product={product}/>
                           <Flex justify={"center"} gap={"middle"} style={{marginTop: "15px"}}
                           >
                               <Button block danger onClick={() => setOpen(true)}>حذف</Button>
                               <Button block type={"primary"} onClick={() => navigate( `/ad-edit-step-one/${id}`)}>ویرایش</Button>
                           </Flex>
                       </Flex>
                   }
               </Flex>
                     <Modal
                         open={open}
                         onCancel={onCansel}
                         title={" "}
                         width={"100%"}
                         footer={null}
                         transitionName={''}
                         closable={false}

                     >
                         <Flex vertical={true} gap={"large"}>
                             <Alert
                                 description="آیا از حذف این آگهی اطمینان دارید ؟"
                                 type="error"
                                 showIcon
                                 message="حذف"
                             />
                             <Flex justify={"center"} gap={"large"} align={"center"}>
                                 <Button danger loading={deleteBtnLoading} block onClick={()  => {
                                     _deleteProduct()
                                 }}>حذف</Button>
                                 <Button block loading={deleteBtnLoading} onClick={() => onCansel()}>انصراف</Button>
                             </Flex>
                         </Flex>
                     </Modal>

            </Flex>

    );
};

export default connect(null, {getProductDetail,deleteProduct})(withRouter(MyProductDetail));
